import { Tabs } from "antd";
import { ComparisonSection } from "../ComparisonSection";
import React from "react";

export const SimilarityTab = () => {
    const a = [
        {
            name: "18-1-1",
            id: '18-1-1',
            similarities: [
                { id: '18-1-2', name: '18-1-2', similarity: 0.3 },
                { id: '18-1-3', name: '18-1-3', similarity: 0.6 },
                { id: '18-1-4', name: '18-1-4', similarity: 0.9 },
            ],
        },
        {
            name: "18-1-2",
            id: '18-1-2',
            similarities: [
                { id: '18-1-1', name: "18-1-1", similarity: 0.3 },
                { id: '18-1-3', name: '18-1-3', similarity: 0.6 },
                { id: '18-1-4', name: '18-1-4', similarity: 0.9 },
            ],
        },
        {
            name: "18-1-3",
            id: '18-1-3',
            similarities: [
                { id: '18-1-1', name: "18-1-1", similarity: 0.6 },
                { id: '18-1-2', name: '18-1-2', similarity: 0.6 },
                { id: '18-1-4', name: '18-1-4', similarity: 0.3 },
            ],
        },
        {
            name: "18-1-4",
            id: '18-1-4',
            similarities: [
                { id: '18-1-1', name: "18-1-1", similarity: 0.9 },
                { id: '18-1-2', name: '18-1-2', similarity: 0.9 },
                { id: '18-1-3', name: '18-1-3', similarity: 0.3 },
            ],
        },
    ];

    return (
        <div style={{ padding: "30px" }}>
            <Tabs
                defaultActiveKey="1"
                tabPlacement={'top'}
                style={{ maxHeight: '100%', overflowY: 'auto' }}
                items={a.map(articleInfo => {
                    const id = articleInfo.id;
                    return {
                        label: `Tab-${id}`,
                        key: id,
                        children: <div>            <Tabs
                            defaultActiveKey="1"
                            tabPlacement={'start'}
                            style={{ maxHeight: '100%', overflowY: 'auto' }}
                            items={articleInfo.similarities.map((similarity) => {
                                const id = similarity.id;
                                return {
                                    label: `${similarity.name} (Similarity: ${similarity.similarity})`,
                                    key: id,
                                    children: <>
                                    
                                    <div>`Content of tab ${id}`</div>
                                    <ComparisonSection />
                                    </>
                                };
                            })}
                        /></div>,
                    };
                })}
            />
        </div>
    );
}